// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1300":"3f5b2204","3007":"ad5338a6","4280":"fdf76213","8377":"56f71106","9320":"d14956c4"}[chunkId] + ".chunk.css";
};